import { SecondaryButton } from 'cdk-radial';
import styled from 'styled-components';

export const StyledSelectedVendorsSpan = styled.span`
  color: var(--text-icons-light-enabled-dark-70, rgba(0, 0, 0, 0.7));
  margin-right: 15px;
  font-family: Roboto, sans-serif;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px;
`;

export const StyledDeclineButton = styled(SecondaryButton)`
  margin-right: 5px;
`;

export const StyledButtonsContainer = styled.div`
  display: flex;
  align-items: center;
`;
